import * as yup from "yup";

export const loginSchema = yup.object().shape({
  email: yup.string().required("E-mail é um campo obrigatório"),
  senha: yup.string().required("Senha é um campo obrigatório"),
  codigo: yup.string(),
  csrf: yup.string()
});
